export const configSavePayload = (data, branch) => {
  let payload = [];
  for (let d in data) {
    payload.push({
      name: d,
      branchCode: branch || undefined,
      value: data[d],
      type: (typeof data[d]).toString().toUpperCase(),
    });
  }
  return payload;
};
